import React, { useEffect, useState } from "react";
import { Alert, Box, Chip, Typography } from "@mui/material";
import dayjs from "dayjs";
import axiosInstance from "@API/axios";
import { GET_ACTIVE_EXTENSION_INFO } from "@API/APIRoutes";

const phaseLabel = {
  IA: "Impact Assessment submission",
  EXIT_PLAN: "Exit Plan submission",
};

const ExtensionStatusBanner = ({ categoryAssignmentId }) => {
  const [activeInfo, setActiveInfo] = useState(null);

  useEffect(() => {
    if (!categoryAssignmentId) return;
    axiosInstance
      .get(`${GET_ACTIVE_EXTENSION_INFO}/${categoryAssignmentId}/active`)
      .then((res) => setActiveInfo(res.data))
      .catch((err) => {
        console.error("Failed to load extension status:", err?.response?.data || err);
        setActiveInfo(null);
      });
  }, [categoryAssignmentId]);

  if (!activeInfo?.extensionAvailable) return null;

  const pending = activeInfo.pendingRequest;
  const latest = activeInfo.latestRequest;
  const approvedWeeks = activeInfo.approvedExtensionWeeks || 0;

  return (
    <Alert severity={pending ? "warning" : approvedWeeks ? "success" : "info"} sx={{ mb: 1 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
        <Typography variant="body2">
          Current extension phase: <strong>{phaseLabel[activeInfo.phase]}</strong>
        </Typography>
        {pending && <Chip label="Extension Pending" size="small" color="warning" />}
        {!pending && approvedWeeks > 0 && (
          <Chip label={`${approvedWeeks} week extension approved`} size="small" color="success" />
        )}
        {latest?.status === "REJECTED" && (
          <Chip label="Latest extension rejected" size="small" color="error" />
        )}
        <Typography variant="body2">
          Effective escalation date:{" "}
          <strong>
            {activeInfo.effectiveEscalationDate
              ? dayjs(activeInfo.effectiveEscalationDate).format("MM/DD/YYYY")
              : "-"}
          </strong>
        </Typography>
      </Box>
    </Alert>
  );
};

export default ExtensionStatusBanner;
